export default "__VITE_ASSET__CpkvkpFU__"